import React from "react";
import { RentLinkedAccountsCreateBankScreenContainer } from "src/containers";

export const RentLinkedAccountsCreateBankScreen = () => {
  return <RentLinkedAccountsCreateBankScreenContainer />;
};
